<div id="clockContainer">
  <div id="hour" [ngStyle]="{transform: 'rotate(' + hourRotation + 'deg)'}"></div>
  <div id="minute" [ngStyle]="{transform: 'rotate(' + minuteRotation + 'deg)'}"></div>
  <div id="second" *ngIf="isShowSecond" [ngStyle]="{transform: 'rotate(' + secondRotation + 'deg)'}"></div>
</div>
